import React, { useContext, useState } from 'react';

const SignInContext = React.createContext();

export const useSignInContext = () => useContext(SignInContext);

const { Provider, Consumer } = SignInContext;

function SignInProvider({ children }) {
  const [signInBox, setSignInBox] = useState(false);
  const toggleSignIn = () => setSignInBox(prev => !prev);

  return <Provider value={{ signInBox, setSignInBox, toggleSignIn }}>{children}</Provider>;
}

export { SignInProvider, Consumer as ConsumerProvider };
export default SignInContext;
